// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAJ_TmSFOw64uySMXcywxUGJ7BZLeYkqCw",
  authDomain: "doctor12.firebaseapp.com",
  databaseURL: "https://doctor12-default-rtdb.firebaseio.com",
  projectId: "doctor12",
  storageBucket: "doctor12.firebasestorage.app",
  messagingSenderId: "727336704178",
  appId: "1:727336704178:web:68a1f491b955a62267d1ab",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
